
define('text!modules/pixel/templates/search.html',[],function () { return '<input type="text" class="text-input" placeholder="Search" />';});

